import { Button } from 'primereact/button';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import FileService from '../service/FileService';



const CustomFollowLayer = (props) => {

    const { t } = useTranslation();
    const navigate = useNavigate();


    const onClick = () => {
        console.log("onClick props.param.isFollow", props.param.isFollow, props);
        if (props.param.isFollow === 0) {
            console.log("onClick", props.param.id);
            props.followUser(props.param.id);
            props.param.isFollow = 1;
        } else if (props.param.isFollow == 1) {
            console.log("onClick", props.param.id);
            props.unFollowUser(props.param.id);
            props.param.isFollow = 0;
        }

        console.log("onClick", props)

    }

    const layer = () => {
        console.log("1111 CustomFollowLayer", props);
        return (
            <div className="pl-3 pr-2 pb-3 pt-3" >
                <div className="follow-section" >
                    <div className="follow-bg-section">
                        <div className="follow-bg-section-above flex align-items-center justify-content-center" >
                            <div className="text-500 w-3 font-medium text-right  pl-1 pr-3" >

                                <a href={"/profile/" + props.param.id + "/" + props.param.userType}  >
                                    <img src={props.param.profileImage ? FileService.inquireFilePath(props.param.profileImage) : "/assets/layout/images/profile-image.png"} height={32} width={32} style={{ borderRadius: 16, boxShadow: 'rgb(200, 200, 200) 1px 2px 9px', }}></img>
                                </a>

                            </div>
                            <div className="w-8  align-items-left pl-0"  >
                                <div className="font-white w-12 text-xl flex align-items-center font-400-regular" >
                                    {props.param.firstName + " " + props.param.lastName}

                                    <div
                                        className="blue-check-point ml-1 mt-1"  >
                                        <i className="fas fa-check" style={{ fontSize: '12px' }} ></i>


                                    </div>
                                </div>
                                <div className="w-12  font-normal font-gray font-400-regular" >
                                    @{props.param.userName}
                                </div>
                            </div>
                            <div className="text-500 w-3 font-medium text-left pt-1 pl-2" >
                                {props.param.isFollow >= 0 &&
                                    <Button onClick={() => onClick()} icon={props.param.isFollow === 0 ? "fas fa-user-plus" : " fas fa-user-check"} className={"p-button-rounded  mr-2 mb-2" + (props.param.isFollow === 0 ? " p-button-header" : "")} />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }



    return (
        <div key={props.key} style={{
            ...props.containerStyle,



        }}>
            {layer()}

        </div>
    )
}

export default CustomFollowLayer;
